import { JsonObject } from '../app/json/jsonObject.js';
import { ResourceStatistics } from './resourceStatistics.js';
import type { PreprocessedTemplate } from './preprocessedTemplate.js';

export class PreProcessTemplateEntry {
    template: PreprocessedTemplate;
    json: JsonObject | null;

    constructor(template: PreprocessedTemplate, json: JsonObject | null = null) {
        this.template = template;
        this.json = json;
    }

    get Template(): PreprocessedTemplate {
        return this.template;
    }

    get Json(): JsonObject | null {
        return this.json;
    }
}

type PreProcessTemplateStoreMap = Map<string, PreProcessTemplateEntry>;

export class PreProcessTemplateStore {
    _appSiteCache: Map<string, PreProcessTemplateStoreMap> = new Map();
    _resourceStatsCache: Map<string, ResourceStatistics> = new Map();

    hasAppSite(appSite: string): boolean {
        for (const cachedAppSite of this._appSiteCache.keys()) {
            if (cachedAppSite === appSite) {
                return true;
            }
        }
        return false;
    }

    tryGetTemplates(appSite: string): PreProcessTemplateStoreMap | undefined {
        if (!this._appSiteCache.has(appSite)) {
            return undefined;
        }

        return this._appSiteCache.get(appSite);
    }

    getTemplates(appSite: string): PreProcessTemplateStoreMap | undefined {
        if (!this._appSiteCache.has(appSite)) {
            return undefined;
        }

        return this._appSiteCache.get(appSite);
    }

    AddAppSite(appSite: string, templates: PreProcessTemplateStoreMap): boolean {
        if (!this._appSiteCache.has(appSite)) {
            this._appSiteCache.set(appSite, templates);
            return true;
        }
        return false;
    }

    SetTemplates(appSite: string, templates: PreProcessTemplateStoreMap): void {
        if (this._appSiteCache.has(appSite)) {
            this._appSiteCache.delete(appSite);
        }
        this._appSiteCache.set(appSite, templates);
    }

    getAllAppSites(): Map<string, PreProcessTemplateStoreMap> {
        return this._appSiteCache;
    }

    getAppSiteCount(): number {
        return this._appSiteCache.size;
    }

    tryGetResourceStats(appSite: string): ResourceStatistics | undefined {
        if (!this._resourceStatsCache.has(appSite)) {
            return undefined;
        }

        return this._resourceStatsCache.get(appSite);
    }

    setResourceStats(appSite: string, stats: ResourceStatistics): void {
        if (this._resourceStatsCache.has(appSite)) {
            this._resourceStatsCache.delete(appSite);
        }
        this._resourceStatsCache.set(appSite, stats);
    }

    clear(): void {
        this._appSiteCache.clear();
        this._resourceStatsCache.clear();
    }
}
